/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';


/*Components*/
import SelectBox from '../../components/formComponents/selectBox';

/*Assets*/

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';


class ChangeLocationModal extends Component {
  constructor(props){
    super(props);
    this.state = {
        changeLocation: false,
        locality: null
    }
  }
   selectChange = async (category) => {
    await this.setState({category: category});
  }

  changeTab(e){
    let changeLocation = this.state.changeLocation;
    this.setState({changeLocation: !changeLocation});
  }


  componentDidMount() {
    this.setState({locality: this.props.selectedLocation});
  }

  render() {

    return (
      <div className="modal fade e-ad-detail-wrap e-ofer-modal" id="changeLocationModal" tabIndex="-1" role="dialog" aria-labelledby="changeLocationModalModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered e-sample-ad-modal"  role="document">
          <div className="modal-content e-ofer e-purchase-modal p-4">
            <div className="modal-header">
                  <h3 className="mb-0">
                      {
                          this.state.changeLocation?
                          "Select Location"
                          :
                          "Confirm Action"
                      }
                  </h3>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {
                !this.state.changeLocation?
                <div className="container pt-4">
                <div className="row">
                    <div className="col-12">
                        <p>Are you sure you want to change location? You will loose all your purchased ad plans and remaining hours once location is changed.</p>
                    </div>
                    <div className="col-12 pt-3">
                        <div className="d-flex w-100 justify-content-end">
                            <button className="e-s-btn e-normal-btn" onClick={this.changeTab.bind(this)}>Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div className="container pt-4">
                <div className="row">
                    <div className="col-12" style={{zIndex: 10}}>
                        <SelectBox options={this.props.locationOptions} selectchange={(val)=>{this.setState({locality: val})}} defaultValue={this.state.locality}/>
                    </div>
                    <div className="col-12 pt-3">
                        <div className="d-flex w-100 justify-content-end">
                            <button className="e-s-btn e-normal-btn" onClick={()=>this.props.updateLocation(this.state.locality)}>Change</button>
                        </div>
                    </div>
                </div>
            </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ChangeLocationModal;
